import "./style.css";
function CardCertificadoSelecionado({
  image,
  valor,
  titulo,
  modelo,
  formato,
  validade,
}) {
  return (
    <div class="layout-cs" style={{ color: "#4C4C4C" }}>
      <span class="mensagem-cs">
        Você escolheu o <br /> <b class="text-gold">e-{titulo}</b>
      </span>

      <div class="card-container-cs">
        <img src={image} width="120" alt="Icone Certificado" />
        <span class="valor-cs">R${valor}</span>
        <div class="info-container-cs">
          <span className="info-titulo-cs">e-{titulo}</span>
          <span>Modelo: {modelo}</span>
          <span>Formato: {formato}</span>
          <span>Validade: {validade}</span>
        </div>
      </div>
    </div>
  );
}

export default CardCertificadoSelecionado;
